(function(){
  'use strict';
  const body=document.body;
  const theme=window.theme||{};
  const routes=theme.routes||{};
  const moneyFormat=theme.moneyFormat||'${{amount}}';

  function money(cents){
    const n=Number(cents||0);
    const amount=(n/100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/,amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/,String(Math.round(n/100)));
  }

  const drawer=document.querySelector('[data-cart-drawer]');
  const overlay=document.querySelector('[data-cart-overlay]');
  function openCart(){
    if(!drawer)return;
    body.classList.add('cart-open');
    drawer.setAttribute('aria-hidden','false');
  }
  function closeCart(){
    if(!drawer)return;
    body.classList.remove('cart-open');
    drawer.setAttribute('aria-hidden','true');
  }
  document.addEventListener('click',e=>{
    const open=e.target.closest('[data-cart-toggle]');
    const close=e.target.closest('[data-cart-close]');
    if(open){e.preventDefault();openCart();}
    if(close){
      closeCart();
      if(close.tagName === 'BUTTON' || close.getAttribute('href') === null) e.preventDefault();
    }
  });
  if(overlay)overlay.addEventListener('click',closeCart);
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeCart();closeSearch();}});

  const mobileToggle=document.querySelector('[data-mobile-toggle]');
  const mobileNav=document.querySelector('[data-mobile-nav]');
  if(mobileToggle&&mobileNav){
    mobileToggle.addEventListener('click',()=>{
      const open=mobileNav.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded',open?'true':'false');
    });
  }

  const searchToggle=document.querySelector('[data-search-toggle]');
  const searchPanel=document.querySelector('[data-search-panel]');
  function openSearch(){
    if(!searchPanel)return;
    searchPanel.classList.add('is-open');
    searchPanel.setAttribute('aria-hidden','false');
    const input=searchPanel.querySelector('input[name="q"]');
    if(input)setTimeout(()=>input.focus(),30);
  }
  function closeSearch(){
    if(!searchPanel)return;
    searchPanel.classList.remove('is-open');
    searchPanel.setAttribute('aria-hidden','true');
  }
  if(searchToggle){
    searchToggle.addEventListener('click',e=>{
      e.preventDefault();
      if(searchPanel?.classList.contains('is-open'))closeSearch();else openSearch();
    });
  }

  async function getCart(){
    const r=await fetch((routes.cart||'/cart')+'.js',{headers:{Accept:'application/json'},credentials:'same-origin'});
    if(!r.ok)throw new Error('cart fetch failed');
    return r.json();
  }

  function renderCartItems(cart){
    const bodyEl = document.querySelector('[data-cart-body]');
    if(!bodyEl) return;

    if(!cart.items || cart.items.length === 0){
      bodyEl.innerHTML = `
        <div class="empty-cart">
          <div class="empty-cart-icon">◇</div>
          <h3>Your cart is empty</h3>
          <p>Discover something premium for your next project.</p>
          <a class="btn btn-gold" href="${routes.all_products_collection_url || '/collections/all'}">EXPLORE PRODUCTS</a>
        </div>
      `;
      return;
    }

    let itemsHtml = '';
    cart.items.forEach((item, idx) => {
      const lineNum = idx + 1;
      const imgHtml = item.image 
        ? `<img src="${item.image}" alt="${item.title.replace(/"/g, '&quot;')}" width="180">` 
        : '';

      itemsHtml += `
        <div class="cart-line" data-line="${lineNum}">
          <div class="cart-line-image">${imgHtml}</div>
          <div class="cart-line-info">
            <a href="${item.url}">${item.product_title || item.title}</a>
            <span class="cart-line-price">${money(item.final_line_price)}</span>
            <div class="qty">
              <button type="button" data-cart-minus data-line="${lineNum}">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-plus data-line="${lineNum}">+</button>
            </div>
          </div>
          <button type="button" class="remove-line" data-cart-remove data-line="${lineNum}">×</button>
        </div>
      `;
    });
    bodyEl.innerHTML = itemsHtml;
  }

  function updateCartUi(cart){
    document.querySelectorAll('[data-cart-count]').forEach(el=>{
      el.textContent=cart.item_count;
      el.style.display = cart.item_count === 0 ? 'none' : '';
    });
    document.querySelectorAll('[data-cart-total]').forEach(el=>el.textContent=money(cart.total_price));
    document.querySelectorAll('[data-cart-price]').forEach(el=>{
      el.textContent=money(cart.total_price);
      el.style.display = cart.item_count === 0 ? 'none' : '';
    });
    document.querySelectorAll('[data-cart-checkout]').forEach(el=>{
      const disabled=cart.item_count<1;
      el.setAttribute('aria-disabled',disabled?'true':'false');
      if(disabled)el.setAttribute('tabindex','-1'); else el.removeAttribute('tabindex');
    });

    renderCartItems(cart);
  }

  async function refreshCart(openAfter){
    try{
      const cart=await getCart();
      updateCartUi(cart);
      if(openAfter)openCart();
      return cart;
    }catch(err){
      window.location.reload();
    }
  }

  async function addToCart(id,qty){
    const r=await fetch((routes.cartAdd||'/cart/add')+'.js',{
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',
      body:JSON.stringify({items:[{id:Number(id),quantity:Number(qty||1)}]})
    });
    if(!r.ok){let data={};try{data=await r.json()}catch(_){};throw new Error(data.description||'Could not add this product to cart.');}
    return r.json();
  }

  document.addEventListener('click',async e=>{
    const btn=e.target.closest('[data-quick-add]');
    if(!btn||btn.disabled)return;
    e.preventDefault();btn.disabled=true;const old=btn.innerHTML;btn.innerHTML='✓';
    try{await addToCart(btn.dataset.quickAdd,1);await refreshCart(true);}
    catch(err){alert(err.message);btn.innerHTML=old;btn.disabled=false;}
  });

  document.querySelectorAll('[data-product-form]').forEach(form=>form.addEventListener('submit',async e=>{
    e.preventDefault();
    const btn=form.querySelector('button[type="submit"]');
    const data=new FormData(form);const id=data.get('id');const qty=Number(data.get('quantity')||1);
    if(!id)return;
    btn.disabled=true;const old=btn.textContent;btn.textContent='ADDING...';
    try{
      await addToCart(id,qty);
      btn.textContent='ADDED ✓';
      await refreshCart(true);
      setTimeout(()=>{btn.textContent=old;btn.disabled=false;},700);
    }
    catch(err){alert(err.message);btn.textContent=old;btn.disabled=false;}
  }));

  async function changeLine(line,qty){
    const r=await fetch((routes.cartChange||'/cart/change')+'.js',{
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',
      body:JSON.stringify({line:Number(line),quantity:Number(qty)})
    });
    if(!r.ok)throw new Error('Could not update cart.');
    return r.json();
  }

  document.addEventListener('click',async e=>{
    const minus=e.target.closest('[data-cart-minus]');
    const plus=e.target.closest('[data-cart-plus]');
    const remove=e.target.closest('[data-cart-remove]');
    const control=minus||plus||remove;
    if(!control)return;
    e.preventDefault();
    const row=control.closest('.cart-line');
    const q=Number(row?.querySelector('.qty span')?.textContent||1);
    const next=remove?0:(plus?q+1:Math.max(0,q-1));
    control.disabled=true;
    try{
      const cart = await changeLine(control.dataset.line,next);
      updateCartUi(cart);
    }
    catch(err){alert(err.message);control.disabled=false;}
  });

  // Wishlist logic
  function wishlist(){try{return JSON.parse(localStorage.getItem('pr-wishlist')||'[]')}catch(_){return []}}
  function saveWishlist(list){localStorage.setItem('pr-wishlist',JSON.stringify(list));}
  function syncWishlist(){
    const list=wishlist();
    document.querySelectorAll('[data-wishlist]').forEach(btn=>{
      const active=list.includes(btn.dataset.wishlist);
      btn.classList.toggle('is-active',active);
      btn.setAttribute('aria-pressed',active?'true':'false');
      btn.textContent=active?'♥':'♡';
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(el=>{el.textContent=list.length;el.hidden=list.length===0;});
  }
  document.addEventListener('click',e=>{
    const btn=e.target.closest('[data-wishlist]');
    if(btn){
      e.preventDefault();
      const list=wishlist();const h=btn.dataset.wishlist;
      const next=list.includes(h)?list.filter(x=>x!==h):list.concat(h);
      saveWishlist(next);syncWishlist();
    }
    const toggle=e.target.closest('[data-wishlist-toggle]');
    if(toggle){
      e.preventDefault();
      const count=wishlist().length;
      if(count===0){alert('Your wishlist is empty. Tap the ♡ on any product to save it.');return;}
      const first=wishlist()[0];
      const card=document.querySelector('[data-wishlist="'+CSS.escape(first)+'"]');
      if(card)card.scrollIntoView({behavior:'smooth',block:'center'});
      else alert(count+' item'+(count>1?'s':'')+' saved in your wishlist on this device.');
    }
  });
  syncWishlist();

  const cartForm=document.querySelector('[data-cart-page-form]');
  if(cartForm){
    cartForm.addEventListener('submit',()=>{
      const btn=cartForm.querySelector('button[type="submit"]');
      if(btn){btn.disabled=true;btn.textContent='UPDATING...';}
    });
  }
})();